import {
	Component,
	EventEmitter,
	Inject,
	Input,
	OnInit,
	Output,
	ViewEncapsulation,
} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {
	ANNUAL_VOLUME_DISPLAY,
	DATE_TIME,
	FROM_UTC,
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	LOAD_VOLUME_DURATION,
	ProjectDTO,
	RestService,
	SET_TIME_TO_START_OF_THE_DAY,
	TODAY,
} from 'cargo-chief-commons';
import { UtilService } from '@service/util/util.service';
import { UrlService } from '@service/url/url.service';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { TOOLTIP_MSG } from '@domain/constants/app-variables';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';

@Component({
	selector: 'app-request-for-proposal',
	templateUrl: './request-for-proposal.component.html',
	styleUrls: ['./request-for-proposal.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class RequestForProposalComponent implements OnInit {
	@Input() buttonText = '';
	@Input() projectDTO: ProjectDTO = null;
	@Input() numberOfCarriers: number = 0;
	@Input() isOnRecommendedTab: boolean = false;
	@Input() useMenuButton: boolean = false;
	@Output() updatedData = new EventEmitter<string>();

	IS_NULL_OR_UNDEFINED = IS_NULL_OR_UNDEFINED;

	constructor(public dialog: MatDialog, public utilService: UtilService) {}

	ngOnInit() {}

	openRFPDialog() {
		const dialogRef = this.dialog.open(RFPDialog, {
			width: '600px',
			data: {
				projectDTO: this.projectDTO,
				numberOfCarriers: this.numberOfCarriers,
			},
			disableClose: true,
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (!this.utilService.isNullOrUndefined(result)) {
				this.updatedData.emit(result);
			}
		});
	}

	getTooltipMessage() {
		if (IS_NULL_OR_UNDEFINED(this.numberOfCarriers) || this.numberOfCarriers == 0) {
			return 'Please procure carriers to check capacity for this project';
		}
		if (this.isRFPRequestedToday()) {
			const rfpRequestedAt = DATE_TIME(FROM_UTC(this.projectDTO.rfpRequestedDate));
			return `Capacity can be checked once in a day. Last Capacity Check: ${rfpRequestedAt}`;
		}
		if (this.isOnRecommendedTab) {
			return 'Please switch to Procured tab to Check Capacity';
		}
		return 'Send an email to pick up where you left off with your project carriers. See who has a truck coming up and at what rate.';
	}

	isRFPRequestedToday(): boolean {
		let result = false;
		const startOfToday = SET_TIME_TO_START_OF_THE_DAY(TODAY());
		if (
			IS_NOT_NULL_OR_UNDEFINED(this.projectDTO) &&
			IS_NOT_NULL_OR_UNDEFINED(this.projectDTO.rfpRequestedDate) &&
			new Date(this.projectDTO.rfpRequestedDate).getTime() >= startOfToday.valueOf()
		) {
			result = true;
		}
		return result;
	}
}

@Component({
	selector: 'app-RFP-dialog',
	templateUrl: 'modal.html',
})
export class RFPDialog implements OnInit {
	isRequestInProgress: boolean = false;
	IS_NOT_EMPTY = IS_NOT_EMPTY;
	TOOLTIP_MSG = TOOLTIP_MSG;
	isEditingAnnualVolume: boolean = false;
	ANNUAL_VOLUME_DISPLAY: any = '';
	ANNUAL_VOLUME_TOOLTIP: any = '';
	loadVolumeDuration = [
		LOAD_VOLUME_DURATION.DAY,
		LOAD_VOLUME_DURATION.WEEK,
		LOAD_VOLUME_DURATION.MONTH,
		LOAD_VOLUME_DURATION.YEAR,
	];

	constructor(
		public dialogRef: MatDialogRef<RFPDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public utilService: UtilService,
		private urlService: UrlService,
		private restService: RestService,
		private segmentWrapper: SegmentWrapperService,
		public accountSettings: AccountSettingsService
	) {}

	ngOnInit() {
		this.setAnnualVolumeDisplay();
	}

	sendEmailToCarriers() {
		this.isRequestInProgress = true;
		const url = this.urlService.projectRateRequest(
			this.data.projectDTO.id,
			'Volume',
			`${this.data.projectDTO.loadVolume}/${this.data.projectDTO.loadVolumeDuration}`
		);
		this.restService.GET(url).subscribe(
			(response) => {
				this.utilService.showSnackbar(
					`The selected carriers have been contacted for rates.`,
					SNACKBAR.SUCCESS,
					SNACKBAR.ACTION
				);
				this.isRequestInProgress = false;
				this.closeDialog(true);
			},
			(error) => {
				this.utilService.showSnackbar(
					'Unable to send emails to all carriers now. Please try again later.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
				this.isRequestInProgress = false;
			}
		);
	}

	setAnnualVolumeDisplay() {
		if (
			this.accountSettings.ANNUAL_VOLUME &&
			IS_NOT_NULL_OR_UNDEFINED(this.data.projectDTO.loadVolume) &&
			IS_NOT_NULL_OR_UNDEFINED(this.data.projectDTO.loadVolumeDuration)
		) {
			this.ANNUAL_VOLUME_DISPLAY = ANNUAL_VOLUME_DISPLAY(this.data.projectDTO);
			this.ANNUAL_VOLUME_TOOLTIP = `${this.data.projectDTO.loadVolume}/${this.data.projectDTO.loadVolumeDuration}`;
		}
	}

	getLabelVolumeValue() {
		if (this.accountSettings.ANNUAL_VOLUME) {
			return this.ANNUAL_VOLUME_DISPLAY;
		} else if (
			IS_NOT_NULL_OR_UNDEFINED(this.data.projectDTO.loadVolume) &&
			IS_NOT_NULL_OR_UNDEFINED(this.data.projectDTO.loadVolumeDuration)
		) {
			return `${this.data.projectDTO.loadVolume}/${this.data.projectDTO.loadVolumeDuration}`;
		}
	}

	closeDialog(data: any): void {
		this.dialogRef.close(data);
	}
}
